module.exports = __webpack_public_path__ + "img/adidas_70.219e4c27.gif";